
export const API_BASE_URL = 'https://inloopapp-api.iosx.in/api/v1/'
export const API_BASE_ADMINURL = 'https://inloopadminapi.iosx.in/api/v1/'
// export const API_BASE_URL = 'http://192.168.31.21:1998/api/v1/'

